import React, { useImperativeHandle, useEffect, useState, useMemo } from 'react';
import { message, Spin, Alert, Select } from 'antd';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';
import useGroups from '../../gql/hooks/useGroups';
import './styles.less';

const FormCompanyRelationship = ( { form, modifiedCallback, ref } ) => {
    const [ companyRelationshipIds, setCompanyRelationshipIds ] = useState( [] );
    const [ sync ] = useSyncObjectRelationships();
    const { groups, groupsLoading, groupsError } = useGroups();
    
    useImperativeHandle( ref, () => ( {
        reset() {
            reset();
        },
        isModified() {
            return form.getFieldValue( 'companyRelationshipIdsAreModified' );
        },
        async syncData() {
            const syncData = courseFormUtils.getCompanyRelationshipSyncValues( form );

            if ( syncData ) {
                try {
                    await sync( { variables: { input: syncData } } );
                    courseFormUtils.updateCompanyRelationshipValues( form, syncData.relatedResourceIds );
                    reset();
                    return true;
                } catch ( error ) { 
                    console.error( 'Error saving!', error );  
                    message.error( 'Error saving!' );  
                    return false;
                } 
            }
        }
    } ) );
     
    const reset = () => {
        form.setFieldsValue( { companyRelationshipIdsAreModified: false } ); 
        form.setFieldsValue( { companyRelationshipIdsModified: [] } ); 
        setCompanyRelationshipIds( form.getFieldValue( 'companyRelationshipIds' ) );
        modifiedCallback( false ); 
    };

    const listData = useMemo( () => { 
        return groups.filter( i => {
            return i.attributes.find( a => a.name === 'company-relationship' );
        } );
    }, [ groups ] );

    useEffect( () => listData && setCompanyRelationshipIds( form.getFieldValue( 'companyRelationshipIds' ) ), 
        [ listData, setCompanyRelationshipIds ] );

    const handleChangeIds = ( values ) => {
        setCompanyRelationshipIds( values ); 

        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'companyRelationshipIds' ) ) ) {
            form.setFieldsValue( { companyRelationshipIdsAreModified: true } ); 
            form.setFieldsValue( { companyRelationshipIdsModified: values } ); 
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { companyRelationshipIdsAreModified: false } ); 
            form.setFieldsValue( { companyRelationshipIdsModified: [] } ); 
            modifiedCallback( false );
        }
    };

    return (
        <div className="form-item-company-relationship">
            { groupsLoading && 
                <Spin />
            }
            
            { groupsError && 
                <Alert 
                    type="error"
                    message="Error"
                    description="An unknown error occurred. Please try again later."
                />
            }

            { groupsError && 
                <Alert 
                    type="error"
                    message="Error"
                    description="An unknown error occurred. Please try again later."
                />
            }

            { !groupsLoading && !groupsError &&
                <>
                    <h4 style={ { marginBottom: '8px' } }>User Relationship to Company</h4>
                    <Select
                        mode="multiple"
                        value={ companyRelationshipIds }
                        placeholder="Select" 
                        onChange={ handleChangeIds }
                        filterOption={ ( input, option ) => 
                            ( option?.children ? 
                                option.children[ 0 ].type ? '' : option.children[ 0 ]
                                : '' ).toLowerCase().includes( input.toLowerCase() )
                        }
                    >
                        {
                            listData.map( i => {
                                return ( 
                                    <Select.Option 
                                        key={ i.id } 
                                        value={ i.id }  
                                    >
                                        { i.name || <span className='italic'>No Name</span> }
                                    </Select.Option>
                                );
                            } )
                        }
                    </Select>
                </>
            }
        </div>
    );
};

export default FormCompanyRelationship;
